// Webpack Imports
import 'bootstrap';

AOS.init({once: true});

"use strict";
!function () {
    var e = document.querySelectorAll("[data-choices]");
    "undefined" != typeof Choices && e && [].forEach.call(e, function (e) {
        !function (e) {
            var t = e.dataset.choices ? JSON.parse(e.dataset.choices) : {}, o = {
                searchEnabled: !1,
                classNames: {
                    containerInner: e.className,
                    list: "none",
                    listSingle: "none",
                    listDropdown: "dropdown-menu",
                    itemChoice: "dropdown-item",
                    activeState: "show",
                    selectedState: "active"
                }
            }, n = Object.assign(o, t);
            new Choices(e, n)
        }(e)
    })
}(), function () {
    var e = document.querySelectorAll(".navbar-nav .dropdown, .navbar-nav .dropright"), n = ["mouseenter"],
        a = ["mouseleave", "click"];
    [].forEach.call(e, function (t) {
        var o = t.querySelector(".dropdown-menu");
        n.forEach(function (e) {
            t.addEventListener(e, function () {
                !function (e) {
                    window.innerWidth < 992 || (e.classList.add("showing"), setTimeout(function () {
                        e.classList.remove("showing"), e.classList.add("show")
                    }, 1))
                }(o)
            })
        }), a.forEach(function (e) {
            t.addEventListener(e, function (e) {
                !function (e, t) {
                    setTimeout(function () {
                        window.innerWidth < 992 || t.classList.contains("show") && ("click" === e.type && e.target.closest(".dropdown-menu form") || (t.classList.add("showing"), t.classList.remove("show"), setTimeout(function () {
                            t.classList.remove("showing")
                        }, 200)))
                    }, 2)
                }(e, o)
            })
        })
    })
}(), function () {
    var e = document.querySelectorAll(".navbar-togglable"), t = document.querySelectorAll(".navbar-collapse"),
        o = ["load", "scroll"], n = !1;

    function a(e) {
        var t = window.pageYOffset;
        t && !n && function (e) {
            e.classList.remove("navbar-dark"), e.classList.add("navbar-light"), e.classList.add("bg-white"), n = !0
        }(e), t || function (e) {
            e.classList.remove("navbar-light"), e.classList.remove("bg-white"), e.classList.add("navbar-dark"), n = !1
        }(e)
    }

    function i() {
        var e = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.overflow = "hidden", document.body.style.paddingRight = e + "px"
    }

    [].forEach.call(e, function (t) {
        o.forEach(function (e) {
            window.addEventListener(e, function () {
                a(t)
            })
        })
    }), [].forEach.call(t, function (e) {
        $(e).on({
            "show.bs.collapse": function () {
                i()
            }, "hidden.bs.collapse": function () {
                document.documentElement.style.overflow = "", document.body.style.paddingRight = ""
            }
        })
    })
}(), function () {
    var e = document.querySelectorAll('[data-toggle="popover"]');
    e && $(e).popover({template: '<div class="popover" role="tooltip"><div class="arrow"></div><h6 class="popover-header text-uppercase"></h6><div class="popover-body"></div></div>'})
}(), function () {
    var e = document.querySelectorAll('[data-toggle="tooltip"]');
    e && $(e).tooltip()
}();
